export default "__VITE_ASSET__QT9sY$sa__"